import "antd/lib/message/style";
import message from "antd/lib/message";

export default message;
